// Copy-to-clipboard for `.clipboard[data-clipboard-text]` is registered once from
// `packs/application.js` via `lib/clipboardDelegation.js` (runs on DOM ready / turbolinks:load).
// This file remains so `import-glob` / cached builds that expect every initializer path do not fail.
export default function () {}
